export default "__VITE_ASSET__CQBaR_$A__"